import type { McpIntegrationError } from './types';

// Контракт встраивания с коннектором (frontend/src/app/hooks/useEmbeddedSession.ts,
// frontend/src/auth/navigation.ts в mcp-connector). Меняется только вместе с ним.
export const MCP_READY_MESSAGE = 'byhelp.mcp.ready';
export const MCP_SESSION_MESSAGE = 'byhelp.mcp.session';
export const MCP_NAVIGATE_MESSAGE = 'byhelp.mcp.navigate';
export const MCP_OAUTH_COMPLETE_MESSAGE = 'byhelp.mcp.oauth-complete';

export const MCP_APP_PATH = '/app';
export const MCP_CONSENT_APP_PATH = `${MCP_APP_PATH}/consent`;
export const MCP_APPROVALS_APP_PATH = `${MCP_APP_PATH}/approvals`;
export const MCP_AUTHORIZATION_CALLBACK_PATH = '/auth/interaction/callback';

export const MCP_TRANSACTION_PARAM = 'transaction';
export const MCP_TRANSACTION_PATTERN = /^[a-zA-Z0-9_-]{32,128}$/;
export const MCP_UUID_PATTERN =
  /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;
export const MCP_AUTHORIZATION_CODE_PATTERN = /^mcpc_[A-F0-9]{64}$/;
export const MCP_AUTHORIZATION_STATE_PATTERN = /^[a-zA-Z0-9_-]{32,256}$/;

// Сервис отвечает ready после загрузки своей конфигурации. Нет ответа —
// фрейм заблокирован (CSP frame-ancestors), хост недоступен или CRM нет в
// списке origins MCP: пользователю нужен текст и повтор, а не пустой фрейм.
export const MCP_HANDSHAKE_TIMEOUT_MS = 20000;

export const MCP_ERROR_MESSAGES: Record<McpIntegrationError, string> = {
  'access-denied': 'MCP недоступен текущему пользователю CRM',
  'not-configured': 'Сервис MCP не настроен для этой CRM',
  'invalid-link':
    'Ссылка MCP недействительна. Откройте её заново из AI-клиента',
};

export const MCP_HANDSHAKE_TIMEOUT_MESSAGE = 'Сервис MCP не отвечает';
export const MCP_HANDSHAKE_TIMEOUT_DESCRIPTION =
  'Проверьте подключение к интернету и повторите попытку.';
export const MCP_RETRY_LABEL = 'Повторить';
